import { Question } from "../../interfaces/purchase-order.interface";

export class FeeQuestion {
  public static questions_fee: Question[] = [
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "checkbox",
      question: "Marca los datos que aparecen en el comprobante",
      additional_information: "Número de identificación vehicular (NIV)",
      control: "identification_number",
      label: "",
      answer: undefined,
      page: 1,
    },
    {
      type: "checkbox",
      additional_information: "Número de placas capturado",
      control: "plates_number",
      label: "",
      answer: undefined,
      page: 1,
    },
    {
      type: "radio",
      question: "¿La tenencia está pagada correctamente?",
      control: "fee_payment",
      options: [
        { label: "Sí", value: { value: true, incident: false } },
        {
          label: "No",
          value: {
            value: false,
            incident: true,
            incident_text:
              "Aclara la situacion con la agencia o con la entidad gubernamental correspondiente y carga el documento que mejor se ajuste a la resolución obtenida.",
          },
        },
      ],
      page: 2,
    },
  ];

  public static questions_no_payment: Question[] = [
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "checkbox",
      question: "Marca los datos que aparecen en el comprobante",
      additional_information: "Número de identificación vehicular (NIV)",
      control: "identification_number",
      label: "",
      answer: undefined,
      page: 1,
    },
    {
      type: "checkbox",
      additional_information: "Número de placas capturado",
      control: "plates_number",
      label: "",
      answer: undefined,
      page: 1,
    },
    {
      type: "radio",
      question: "¿Necesitas el comprobante de pago?",
      control: "fee_no_payment",
      options: [
        { label: "No, es una Línea de captura.", value: { value: true, incident: false } },
        {
          label: "Sí, pedir comprobante al Especialista.",
          value: {
            value: false,
            incident: true,
            incident_text: "Es necesario que se adjunte un comprobante pago.",
          },
        },
      ],
      page: 2,
    },
    {
      type: "radio-textbox",
      question: "¿Quieres compartir instrucciones de incidencia al especialista?",
      control: "comment_instructions_incident",
      answer: undefined,
      options: [
        { label: "Sí", value: { value: "other", incident: true, show_alternative_question: true } },
        { label: "No", value: { value: "no", incident: false, show_alternative_question: false } },
      ],
      label: "Instrucciones",
      alternative_question: "Escribe las instrucciones de incidencia.",
      page: 3,
    },
  ];

  public static questions_certification: Question[] = [
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "checkbox",
      question: "Marca los datos que aparecen en el comprobante",
      additional_information: "Número de identificación vehicular (NIV)",
      control: "identification_number",
      label: "",
      answer: undefined,
      page: 1,
    },
    {
      type: "checkbox",
      additional_information: "Número de placas capturado",
      control: "plates_number",
      label: "",
      answer: undefined,
      page: 1,
    },
    {
      type: "checkbox",
      additional_information: "Ejercicios cubiertos",
      control: "certification_years",
      label: "",
      answer: undefined,
      multiple: true,
      page: 1,
    },
    {
      type: "radio",
      question: "¿La tenencia está pagada correctamente?",
      control: "fee_payment",
      options: [
        { label: "Sí", value: { value: true, incident: false } },
        {
          label: "No",
          value: {
            value: false,
            incident: true,
            incident_text:
              "Aclara la situacion con la agencia o con la entidad gubernamental correspondiente y carga el documento que mejor se ajuste a la resolución obtenida.",
          },
        },
      ],
      page: 2,
    },
  ];

  public static questions_certification_no_payment: Question[] = [
    {
      type: "radio",
      question: "¿La información es legible?",
      formatted_question: "¿La información es <b>legible</b>?",
      control: "readable_info",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe ser legible: en tamaño carta y con buena nitidez.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "radio",
      question: "¿El escaneo está derecho?",
      formatted_question: "¿El escaneo está <b>derecho</b>?",
      control: "onside_scan",
      options: [
        { label: "Sí", value: { value: "si", incident: false } },
        {
          label: "No",
          value: {
            value: "no",
            incident: true,
            incident_text: "El documento debe estar escaneado en su formato original: en tamaño carta y bien alineado.",
          },
        },
      ],
      page: 1,
    },
    {
      type: "checkbox",
      question: "Marca los datos que aparecen en el comprobante",
      additional_information: "Número de identificación vehicular (NIV)",
      control: "identification_number",
      label: "",
      answer: undefined,
      page: 1,
    },
    {
      type: "checkbox",
      additional_information: "Número de placas capturado",
      control: "plates_number",
      label: "",
      answer: undefined,
      page: 1,
    },
    {
      type: "checkbox",
      additional_information: "Años cubiertos",
      control: "certification_years",
      label: "",
      answer: undefined,
      multiple: true,
      page: 1,
    },
    {
      type: "radio",
      question: "¿Necesitas el comprobante de pago?",
      control: "fee_no_payment",
      options: [
        { label: "No, es una Línea de captura.", value: { value: true, incident: false } },
        {
          label: "Sí, pedir comprobante al Especialista.",
          value: {
            value: false,
            incident: true,
            incident_text: "Es necesario que se adjunte un comprobante pago.",
          },
        },
      ],
      page: 2,
    },
    {
      type: "radio-textbox",
      question: "¿Quieres compartir instrucciones de incidencia al especialista?",
      control: "comment_instructions_incident",
      answer: undefined,
      options: [
        { label: "Sí", value: { value: "other", incident: true, show_alternative_question: true } },
        { label: "No", value: { value: "no", incident: false, show_alternative_question: false } },
      ],
      label: "Instrucciones",
      alternative_question: "Escribe las instrucciones de incidencia.",
      page: 3,
    },
  ];
}
